import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="w-full" style={{ backgroundColor: '#111111' }}>
      <div className="px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          <div>
            <span
              className="text-2xl md:text-3xl font-bold tracking-tight text-white block mb-4"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              <span className="text-primary-500">51</span>每日大赛
            </span>
            <p className="text-white/60 text-sm leading-relaxed max-w-xs">
              网红明星塌房现场猛料实时追踪，每日更新吃瓜，汇聚全网最新最热的娱乐八卦资讯。51每日大赛官网，你的吃瓜第一站。
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 text-white/70 hover:text-white hover:border-white/50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 text-white/70 hover:text-white hover:border-white/50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 text-white/70 hover:text-white hover:border-white/50 transition-colors cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 text-white/70 hover:text-white hover:border-white/50 transition-colors cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>

          <div className="flex flex-col gap-6">
            <div>
              <h4 className="text-white/50 text-xs font-medium uppercase tracking-wider mb-2">联系地址</h4>
              <p className="text-white/80 text-sm">北京市朝阳区望京SOHO T3 12层</p>
            </div>
            <div>
              <h4 className="text-white/50 text-xs font-medium uppercase tracking-wider mb-2">联系邮箱</h4>
              <p className="text-white/80 text-sm">tips@51meiridasai.com</p>
            </div>
            <div>
              <h4 className="text-white/50 text-xs font-medium uppercase tracking-wider mb-2">爆料热线</h4>
              <p className="text-white/80 text-sm">400-888-5151</p>
            </div>
          </div>

          <div>
            <div className="w-full h-40 rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20media%20office%20interior%20with%20warm%20ambient%20lighting%2C%20creative%20workspace%20with%20large%20screens%20showing%20entertainment%20news%2C%20trendy%20urban%20office%20design%2C%20editorial%20photography%2C%20warm%20tones%2C%20professional%20atmosphere&width=600&height=400&seq=footer-brand-01&orientation=landscape"
                alt="51每日大赛品牌形象"
                title="51每日大赛编辑部"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="px-4 md:px-6 py-5">
          <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-white/40 text-xs">
              &copy; {new Date().getFullYear()} 51每日大赛 版权所有
            </p>
            <div className="flex items-center gap-6">
              <Link to="/about" className="text-white/40 text-xs hover:text-white/70 transition-colors whitespace-nowrap cursor-pointer">
                关于我们
              </Link>
              <a href="#" className="text-white/40 text-xs hover:text-white/70 transition-colors whitespace-nowrap cursor-pointer">
                隐私政策
              </a>
              <a href="#" className="text-white/40 text-xs hover:text-white/70 transition-colors whitespace-nowrap cursor-pointer">
                免责声明
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}